import { useState } from 'react';

export default function ContactSection() {
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitting(true);
    const form = e.currentTarget;
    const data = new URLSearchParams();
    const formData = new FormData(form);
    formData.forEach((value, key) => {
      data.append(key, value.toString());
    });
    try {
      await fetch('https://readdy.ai/api/form/d78etu3ll6jbq2vdd9k0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: data.toString(),
      });
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section id="contact" aria-label="お問い合わせフォーム" className="py-20 md:py-28 bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="inline-block text-amber-700 text-sm font-semibold tracking-widest mb-3 uppercase">
            無料相談・お問い合わせ
          </span>
          <h2 className="text-2xl md:text-4xl font-black text-stone-800 leading-tight" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            まずはお気軽にご相談ください
          </h2>
          <p className="mt-4 text-stone-500 text-sm md:text-base max-w-xl mx-auto">
            相談・見積もりは完全無料。しつこい営業は一切いたしません。
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          {submitted ? (
            <div className="text-center py-16 bg-amber-50 rounded-2xl border border-amber-100">
              <div className="w-16 h-16 flex items-center justify-center bg-amber-100 rounded-full mx-auto mb-4">
                <i className="ri-check-line text-amber-600 text-3xl"></i>
              </div>
              <h3 className="text-stone-800 font-bold text-xl mb-2">送信が完了しました</h3>
              <p className="text-stone-500 text-sm">担当者より2営業日以内にご連絡いたします。</p>
            </div>
          ) : (
            <form
              data-readdy-form
              id="contact-form"
              onSubmit={handleSubmit}
              className="bg-stone-50 rounded-2xl p-6 md:p-8 border border-stone-100"
            >
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                <div>
                  <label className="block text-stone-700 text-sm font-semibold mb-1.5">お名前 <span className="text-red-500">*</span></label>
                  <input
                    type="text"
                    name="name"
                    required
                    placeholder="山田 太郎"
                    className="w-full border border-stone-200 rounded-lg px-4 py-3 text-sm text-stone-700 bg-white focus:outline-none focus:border-amber-400"
                  />
                </div>
                <div>
                  <label className="block text-stone-700 text-sm font-semibold mb-1.5">電話番号 <span className="text-red-500">*</span></label>
                  <input
                    type="tel"
                    name="phone"
                    required
                    placeholder="086-000-0000"
                    className="w-full border border-stone-200 rounded-lg px-4 py-3 text-sm text-stone-700 bg-white focus:outline-none focus:border-amber-400"
                  />
                </div>
              </div>
              <div className="mb-4">
                <label className="block text-stone-700 text-sm font-semibold mb-1.5">メールアドレス</label>
                <input
                  type="email"
                  name="email"
                  placeholder="example@email.com"
                  className="w-full border border-stone-200 rounded-lg px-4 py-3 text-sm text-stone-700 bg-white focus:outline-none focus:border-amber-400"
                />
              </div>
              <div className="mb-4">
                <label className="block text-stone-700 text-sm font-semibold mb-1.5">お住まいの地域</label>
                <select
                  name="area"
                  className="w-full border border-stone-200 rounded-lg px-4 py-3 text-sm text-stone-700 bg-white focus:outline-none focus:border-amber-400 cursor-pointer"
                >
                  <option value="">選択してください</option>
                  <option>岡山市南区</option>
                  <option>岡山市中区</option>
                  <option>倉敷市</option>
                  <option>玉野市</option>
                  <option>浅口市</option>
                  <option>その他岡山県南部</option>
                </select>
              </div>
              <div className="mb-6">
                <label className="block text-stone-700 text-sm font-semibold mb-1.5">ご相談内容</label>
                <textarea
                  name="message"
                  rows={4}
                  maxLength={500}
                  placeholder="気になっていること、困っていることをお気軽にお書きください。"
                  className="w-full border border-stone-200 rounded-lg px-4 py-3 text-sm text-stone-700 bg-white focus:outline-none focus:border-amber-400 resize-none"
                />
              </div>
              <button
                type="submit"
                disabled={submitting}
                className="cursor-pointer whitespace-nowrap w-full bg-amber-600 hover:bg-amber-700 disabled:bg-amber-300 text-white font-bold py-4 rounded-full text-base transition-colors flex items-center justify-center gap-2"
              >
                {submitting ? (
                  <><i className="ri-loader-4-line animate-spin"></i>送信中...</>
                ) : (
                  <><i className="ri-send-plane-line"></i>無料相談を申し込む（初月980円）</>
                )}
              </button>
              <p className="text-center text-stone-400 text-xs mt-3">
                個人情報は適切に管理し、サービス提供以外の目的には使用いたしません。
              </p>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}
